import { Box } from "@mui/material";
import powerByLogo from "assets/logos/logo-transparent.png";
import { CheckoutContext } from "contexts/Checkout";
import { SplashPage, SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Map } from "schemas/functions";

import styles from "components/StripeCheckout/styles";

import PlanDetailsForInstagramOnboarding from "./PlanDetailsForInstagramOnboarding";
import PlanDetailsOOO from "./PlanDetailsOOO";
import PlanDetailsProBundle from "./PlanDetailsProBundle";
import PlanDetailsSettings from "./PlanDetailsSettings";

interface Props {
  isSwitchingSubscription: boolean;
  details?: Map;
}

const PlanDetails = ({ isSwitchingSubscription, details }: Props) => {
  const { subscription } = useContext(SubscriptionContext);
  const { plan, splashPageSource } = useContext(CheckoutContext);

  if (splashPageSource === SplashPage.instagram) {
    return <PlanDetailsForInstagramOnboarding />;
  } else if (splashPageSource === SplashPage.ooo) {
    return <PlanDetailsOOO />;
  } else if (splashPageSource === SplashPage.pro_bundle) {
    return <PlanDetailsProBundle />;
  } else {
    return (
      <>
        <Box component="img" src={powerByLogo} sx={styles.poweredByLogo} />

        <PlanDetailsSettings
          displayName={details?.display_name}
          description={details?.description}
          isSwitching={
            isSwitchingSubscription &&
            subscription?.subscription?.planName !== plan
          }
        />
      </>
    );
  }
};

export default PlanDetails;
